import React, {Component, Fragment} from 'react';
import * as Validate from "../../../helpers/validation";

class MessageValidation extends Component {
    render() {
        const {data, validation, message, tag, maxmin, className} = this.props;
        return (
            <Fragment>
                {
                    tag ? (
                        (maxmin) ? (
                            (Validate[tag](data && data, maxmin) || validation) &&
                            <span className={className} style={{color: "red",fontSize: '13px'}}> * {message}</span>
                        ) : (
                            (Validate[tag](data && data) || validation) &&
                            <span className={className} style={{color: "red",fontSize: '13px'}}> * {message}</span>
                        )
                    ) : (
                        validation && <span className={className} style={{color: "red",fontSize: '13px'}}> * {message}</span>
                    )

                }
            </Fragment>
        );
    }
}

export default MessageValidation;